import { ColDef, ValueGetterParams } from "ag-grid-community";
import React, { useEffect, useState } from "react";
import { useSelector } from 'react-redux';
import { UpdateContactsMassActionDeletionStatus } from "../../actions";
import setToast from "../../helpers/toaster.helper";
import { Contact } from "../../models/conversations";
import * as selector from '../../selectors/selectors';
import { ContactService } from "../../services/ContactService";
import { UtilityService } from "../../services/UtilityService";
import ButtonComponent from "../shared/button/button.component";
import { ContactsMassAction, ToasterTexts, buttonLabels, emptyLabels } from "../shared/constants";
import GridComponent from "../shared/grid";
import { ToasterType } from "../shared/toaster/toaster.model";
import SettingsHeader from "./settingsHeader.component";
import { useDispatch } from "react-redux";

interface Props {
    IsLoading: boolean;
}

const BlockedContactsComponent: React.FC<Props> = (props: Props) => {
    const dispatch = useDispatch();

    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)
    const GetBlockedContacts: Contact[] = useSelector(selector.getBlockedContacts)
    const [gridApi, setGridApi] = useState<any>(null);
    const [columnApi, setColumnApi] = useState<any>(null);
    const [selectedRows, setSelectedRows] = useState<Contact[]>([]);
    const [isloading, setIsLoading] = useState<boolean>(false)
    const [blockedContacts, setBlockedContacts] = useState<Contact[]>([])
    const count = blockedContacts.length

    const BlockedContactsColumnDefs: ColDef[] = [
        {
            field: "S.No",
            headerName: "S.No",
            minWidth: 100,
            valueGetter: (params: ValueGetterParams) => {
                return params.node.rowIndex + 1
            },

            headerCheckboxSelection: true,
            checkboxSelection: true,
        },


        {
            field: "Name",
            headerName: "Name",
            valueGetter: (params: ValueGetterParams) => {
                return !!params.data.Name ? params.data.Name : "--"
            }

        },

        {
            field: "PhoneNumber",
            headerName: "Phone Number",
            valueFormatter: (params) => {
                return UtilityService.maskPhoneNumberOnLength(params.data.PhoneNumber)
            },
            valueGetter: (params: ValueGetterParams) => {
                const raw =
                    params.data?.PhoneNumber ||
                    params.data?.MaskedPhoneNumber ||
                    "";
                return `${raw} ${UtilityService.maskPhoneNumberOnLength(raw)} ${raw.replace(/\D/g, "")}`;
            },
        },


    ]

    useEffect(() => {
        setBlockedContacts(GetBlockedContacts)
    }, [GetBlockedContacts])


    const onGridReady = (params) => {
        setGridApi(params.api)
        setColumnApi(params.columnApi)
    }

    const onSelectionChanged = () => {
        let SelectedUsers: Contact[] = gridApi.getSelectedRows()
        if (gridApi && SelectedUsers.length > 0) {
            setSelectedRows(SelectedUsers)
        }
        else {
            setSelectedRows([])
        }

    }

    const UnBlockAll = () => {
        const data = selectedRows.map((item) => {
            if (item.IsBlocked) {
                return item.PhoneNumber;
            }
        }).filter((element) => {
            return element !== undefined;
        });
        const buttonName = ContactsMassAction.UNBLOCK
        const MassActioninfo = {
            ButtonName: buttonName,
            selectedConversations: data.length
        }
        setIsLoading(true)

        ContactService.contactsMassActionDelete(buttonName, data)
            .then((res) => {
                setIsLoading(false);
            })
            .catch((err) => {
                if (err.response.status === 404 || err.response.status === 400 || err.response.status === 500) {
                    setToast(ToasterTexts.SOMETHING_WENT_WRONG_ERROR, ToasterType.DANGER);
                    setIsLoading(false);
                }
                UpdateContactsMassActionDeletionStatus(dispatch, false)
            })

        localStorage.setItem("contactMassAction", JSON.stringify(MassActioninfo))
        UpdateContactsMassActionDeletionStatus(dispatch, true)
    }
    return (
        <>
            <div className={`d-flex flex-direction w-p-100 ${IsMobileDevice ? "" : "mt-2"}`}>
                <SettingsHeader IsMobileDevice={IsMobileDevice} Title={"Blocked"} subTitle={"Your blocked contacts"} count={count} />
            </div>
            <div className={`${IsMobileDevice ? "h-v-83" : " mb-2 h-p-75"}`}>
                <GridComponent
                    ColumnDefs={BlockedContactsColumnDefs}
                    OnGridReady={onGridReady}
                    RowData={blockedContacts}
                    OnSelectionChanged={onSelectionChanged}
                    IsPaginationEnabled={false}
                    EmptyLabel={emptyLabels.BLOCKED_CONTACTS}
                    LockVisible={true}
                    IsSettingsGrid
                />
            </div>
            <ButtonComponent
                OnClick={UnBlockAll}
                ButtonLabel={buttonLabels.UNBLOCK}
                Loading={isloading}
                Variant={!selectedRows.length ? "disabled-btn-small" : "primary-btn-small"}
                ClassName={IsMobileDevice ? " ml-auto mr-2" : "mr-1 ml-auto"}
            />
        </>
    )
}

export default BlockedContactsComponent;
